<script>
  import { style, debugOn, fetchBlocks, fetchBlock } from "./toolbox.js";
  import SliderBlock from "./blocks/SliderBlock.svelte";
  import FeaturesBlock from "./blocks/FeaturesBlock.svelte";
  import PricingBlock from "./blocks/PricingBlock.svelte";
  import GalleryBlock from "./blocks/GalleryBlock.svelte";
  import HeroBlock from "./blocks/HeroBlock.svelte";
  import Footer from  './blocks/Footer.svelte';
  import Header from  './blocks/Header.svelte';

  export let page;
  export let blocks = [];
</script>

<style>
  .debug-tag {
      position: absolute;
      background-color: blue;
      color: white; 
      padding: 5px;
      right: 0px;
      z-index: 10000;
      top: 50%;
      transform: translateY(-50%);
      font: 1em sans-serif;
  }
</style>

<div>
  {#await fetchBlocks(page.id)}
  {:then blocks}
    {#each blocks as b}
      {#await fetchBlock(page.id, b.id)}
      {:then block}
        <div style="{style(block)} position: relative;">
          {#if debugOn()}
            <div class="debug-tag">{block.slug}/{block.name}</div>
          {/if}
          {#if block.slug === "hero"}<HeroBlock block={block} />{/if}
          {#if block.slug === "slider"}<SliderBlock block={block} />{/if}
          {#if block.slug === "features"}<FeaturesBlock block={block} />{/if}
          {#if block.slug === "pricing"}<PricingBlock block={block} />{/if}
          {#if block.slug === "portfolio"}<GalleryBlock block={block} />{/if}
          {#if block.slug === "footer"}<Footer block={block} />{/if}
          {#if block.slug === "header"}<Header block={block} />{/if}
        </div>
      {/await}
    {/each}
  {/await}

  <!-- Add js main source below -->
</div>
